import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setShowServerErrorMessage } from "./errorManagementSlice";
import errorStatusProvider from "../utils/errorStatusProvider";

const initialState = {
  loading: true,
  error: null,
  value: "",
  title: "",
  country_iso3: "",
  options: [],
};

const baseUrl = process.env.REACT_APP_API;

export const fetchSetLanguageData = createAsyncThunk(
  "languageData/fetchSetLanguageData",
  async (language) => {
    return fetch(`${baseUrl}/api/languages/${language}/`, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    }).then((res) => errorStatusProvider(res));
  }
);

export const fetchGetLanguageData = createAsyncThunk(
  "languageData/fetchGetLanguageData",
  async (language) => {
    return fetch(`${baseUrl}/api/languages/${language}/`, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    }).then((res) => errorStatusProvider(res));
  }
);

export const getLanguageData = (language) => async (dispatch) => {
  const result = await dispatch(fetchGetLanguageData(language));
  const { data, responseStatus } = result.payload;
  dispatch(setShowServerErrorMessage(responseStatus));
  return data;
};

export const setLanguageData = (language) => async (dispatch) => {
  const result = await dispatch(fetchSetLanguageData(language));
  const { data, responseStatus } = result.payload;
  dispatch(setShowServerErrorMessage(responseStatus));
  return data;
};

export const languageOptionsSlice = createSlice({
  name: "languageOptions",
  initialState,
  reducers: {
    getValueState: (state) => {
      return state.value;
    },
    changeLanguageOptions: (state, action) => {
      state.value = action.payload;
      const titles = state.options.filter(
        (option) => option.language_code === action.payload
      );

      state.title = titles[0].language;
    },
    resetLanguageState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSetLanguageData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSetLanguageData.fulfilled, (state, action) => {
        state.loading = false;

        if (state.value === "") {
          state.options = [
            action.payload.data.page_content.default_language,
            ...action.payload.data.page_content.optional_languages,
          ];
          state.value =
            action.payload.data.page_content.default_language.language_code;
          state.title =
            action.payload.data.page_content.default_language.language;
          state.country_iso3 =
            action.payload.data.page_content.country_iso3_code;
        }
      })
      .addCase(fetchSetLanguageData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      })
      .addCase(fetchGetLanguageData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGetLanguageData.fulfilled, (state, action) => {
        state.loading = false;
        state.options = [
          action.payload.data.page_content.default_language,
          ...action.payload.data.page_content.optional_languages,
        ];
        state.value =
          action.payload.data.page_content.default_language.language_code;
        state.title =
          action.payload.data.page_content.default_language.language;
        state.country_iso3 = action.payload.data.page_content.country_iso3_code;
      })
      .addCase(fetchGetLanguageData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

export const { changeLanguageOptions, getValueState, resetLanguageState } =
  languageOptionsSlice.actions;

export default languageOptionsSlice.reducer;
